import React from 'react';
import * as _ from 'lodash';
import { FieldTreeService } from '../../../services/FieldTrees';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

export class FieldTreeUserListDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      loaded: false,
      opened: false,
      selected: null,
      fieldTreeId: null,
      options: {},
      error: '',
      condition: {
        name: '',
      },
    };

    this.id = Math.floor(Math.random() * 100000);
    this.targetId = `infinityscroll-target-field-tree-user_list-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getFieldTreeUserList = this.getFieldTreeUserList.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
  }

  componentDidMount() {
    this.getFieldTreeUserList(() => {});
  }

  componentWillReceiveProps(nextProps) {
    // 協力会社が変更された場合
    if (
      !nextProps.fieldTreeId ||
      nextProps.fieldTreeId !== this.state.fieldTreeId
    ) {
      let state = this.state;
      state.loaded = false;
      state.opened = false;
      state.selected = null;
      state.options = {};
      state.fieldTreeId = nextProps.fieldTreeId;
      this.setState(state);

      this.getFieldTreeUserList(() => {});
    }
    if (nextProps.value !== this.state.selected) {
      this.setState({ selected: nextProps.value });
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(props, state) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
  };

  handleOpen = () => {
    this.setState({ opened: !this.state.opened });
  };

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });
  };

  search = () => {
    let state = this.state;
    state.options = {};
    state.loaded = false;
    state.selected = null;
    this.setState(state);

    this.getFieldTreeUserList(() => {});
  };

  handleSelectedRow = (id, checked) => {
    let selected = null;
    if (checked) {
      selected = id;
    }
    this.setState({ selected });
    this.props.set('user_id', selected);
  };

  getFieldTreeUserList(notify) {
    if (this.state.loaded || _.isNull(this.state.fieldTreeId)) {
      notify();
      return;
    }

    let params = {
      field_id: this.state.fieldId,
      field_tree_id: this.state.fieldTreeId,
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
    };

    FieldTreeService.treeUsersList(
      this.state.fieldId,
      this.state.fieldTreeId,
      params
    ).then(response => {
      if (response.result) {
        const fieldTreeUsers = response.data.entities.field_tree_users;
        if (_.isEmpty(fieldTreeUsers)) {
          this.setState({ loaded: true });
        } else {
          let options = this.state.options;
          _.each(fieldTreeUsers, fieldTreeUser => {
            if (_.isEmpty(this.state.selected)) {
              // 1件しかない場合自動セット
              if (_.size(fieldTreeUsers) == 1) {
                this.setState({ selected: fieldTreeUser.user_id });
                this.props.set('user_id', fieldTreeUser.user_id);
              } else {
                this.props.set('user_id', null);
              }
            }
            options[fieldTreeUser.user_id] = fieldTreeUser;
          });
          this.setState({
            options,
            loaded: false,
          });
        }
      }
      notify();
    });
  }

  render() {
    return (
      <div className='form-list__element'>
        <div
          id='form-dropdown'
          className='dropdown-multi-select --col-xs-12 --col-md-12 --col-lg-5 --col-xl-5'
        >
          <div className='dropdown-multi-select__header'>
            <div
              id='form-dropdown-btn'
              href=''
              className='dropdown-select'
              onClick={() => this.handleOpen()}
            >
              <span className='dropdown-select__txt'>
                {this.state.selected && !_.isEmpty(this.state.options)
                  ? this.state.options[this.state.selected].fullname
                  : '作業員を選択'}
              </span>
            </div>
          </div>
          <div
            id='form-dropdown-list'
            className={
              this.state.opened
                ? 'dropdown dropdown--dropdown-list show'
                : 'dropdown dropdown--dropdown-list'
            }
            ref={this.parent}
          >
            <div className='dropdown__item'>
              <div className='dropdown-multi-select__item'>
                <i className='i-search i-2x' />
                <input
                  type='text'
                  className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                  placeholder={messageUtility.getMessage('I-000-090')}
                  onBlur={() => this.search()}
                  onChange={e => this.setCondition(e)}
                />
              </div>
              <div className='dropdown-multi-select__item'>
                <div
                  className='dropdown-multi-select__scroll'
                  id={this.targetId}
                >
                  <ul className='multi-select'>
                    {_.map(this.state.options, (option, index) => (
                      <SelectableOption
                        key={index}
                        option={option}
                        targetId={this.id}
                        checked={this.state.selected === option.user_id}
                        handleSelectedRow={this.handleSelectedRow}
                      />
                    ))}
                    <InfinityScrollLoad
                      targetId={this.targetId}
                      total={_.size(this.state.options)}
                      callback={this.getFieldTreeUserList}
                    />
                  </ul>
                </div>
              </div>
              <div className='dropdown-multi-select__footer'>
                <button
                  className='btn--sm--stay'
                  onClick={() => this.handleOpen()}
                >
                  {messageUtility.getMessage('I-000-091')}
                </button>
              </div>
            </div>
          </div>
          <div className='form-list__alert show'>{this.props.error}</div>
        </div>
      </div>
    );
  }
}

const SelectableOption = ({ option, checked, targetId, handleSelectedRow }) => (
  <li className='multi-select__item'>
    <div className='radio'>
      <label
        htmlFor={`single-field-tree-user-list-${option.user_id}-${targetId}`}
      >
        <input
          id={`single-field-tree-user-list-${option.user_id}-${targetId}`}
          type='radio'
          checked={checked}
          onClick={() => handleSelectedRow(option.user_id, !checked)}
        />
        <i className='i-circle-radio i-2_5x' />
      </label>
    </div>
    <div
      className='multi-select__label'
      onClick={() => handleSelectedRow(option.user_id, !checked)}
    >
      {option.fullname}
    </div>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldTreeUserList.jsx